import { CloseOutlined, EditTwoTone, SaveOutlined } from "@ant-design/icons";
import { Button, Checkbox, Col, Form, Input, Radio, Row, Select } from "antd";
import PracticesService, {
  IPracticeEmailInitialValues,
  ITimeZoneVatInitialValues,
  PracticeUpdateTypes,
} from "../../Services/PracticesService";
import { Utils } from "../../Utilities/Utils";
import React, { useEffect, useState } from "react";
import { adminContext } from "../../Common/PageRoute";
import { getTimeZoneOptions } from "../../Common/TimeZoneUtils";
import { useUser } from "../../Context/UserContext";
const TimeZoneVATAndEmail = ({
  isEdit,
  setIsEdit,
  setLoading,
  practiceId,
}: {
  isEdit: { type: PracticeUpdateTypes };
  setIsEdit: React.Dispatch<
    React.SetStateAction<{ type: PracticeUpdateTypes }>
  >;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  practiceId: number;
}) => {
  // const BCCoptions: SelectProps["options"] = [];
  // const CCoptions: SelectProps["options"] = [];
  // const timeZoneOptions: SelectProps['options'] = [];
  const { isSubAdmin } = useUser();
  const isViewOnly = isSubAdmin();
  const [ccOptions, setCCOptions] = useState<any[]>([]);
  const [bccOptions, setBCCOptions] = useState<any[]>([]);
  const [selectedBcc, setSelectedBcc] = useState<{
    label: string;
    name: string;
  }>();
  const [selectedCC, setSelectedCC] = useState<{
    label: string;
    name: string;
  }>();
  const [initialValues, setInitialValues] = useState<
    ITimeZoneVatInitialValues & IPracticeEmailInitialValues
  >();
  const [form] = Form.useForm();
  const { openNotification } = React.useContext(adminContext);
  // var bCCs = form.getFieldValue("defaultBCCs");
  // var CCs = form.getFieldValue("defaultCCs");

  // bCCs?.forEach((item: any) => {
  //   BCCoptions.push({
  //     label: item,
  //     value: item,
  //   });
  // });
  // CCs?.forEach((item: any) => {
  //   CCoptions.push({
  //     label: item,
  //     value: item,
  //   });
  // });

  const getTimeVatEmailInformation = async () => {
    try {
      setLoading(true);
      const res =
        await PracticesService.getPracticeTimeVatEmailInformation(practiceId);
      if (res?.result && res?.status) {
        const fieldValues = {
          timeZone: res?.result?.timeZone,
          vat: res?.result?.vat,
          emailProvider: res?.result?.emailProvider,
          defaultBCCs: res?.result?.defaultBCCs,
          defaultCCs: res?.result?.defaultCCs,
          noReply: res?.result?.noReply,
        };
        form.setFieldsValue(fieldValues);
        setInitialValues(fieldValues);
      } else {
        openNotification(
          "error",
          res?.message || "Error fetching basic information",
        );
      }
    } catch (error) {
      openNotification("error", "Error fetching basic information");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getTimeVatEmailInformation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [practiceId]);


  const saveTimeVatEmailDetails = async () => {
    try {
      setLoading(true);
      const values = await form.validateFields();

      let request: Promise<any> | null = null;

      if (isEdit.type === PracticeUpdateTypes.timeZoneVat) {
        const params: ITimeZoneVatInitialValues = {
          timeZone: values.timeZone,
          vat: values.vat,
        };
        request = PracticesService.updatePracticeTimezoneVate(
          practiceId,
          params,
        );
      }

      if (isEdit.type === PracticeUpdateTypes.emails) {
        const params: IPracticeEmailInitialValues = {
          emailProvider: values.emailProvider,
          defaultBCCs: values.defaultBCCs,
          defaultCCs: values.defaultCCs,
          noReply: values.noReply,
        };
        request = PracticesService.updatePracticeEmail(practiceId, params);
      }

      if (!request) return;

      const res = await request;

      if (res?.result) {
        openNotification("success", "Information updated successfully");
        setIsEdit({ type: PracticeUpdateTypes.unknown });
        setInitialValues(values);
        getTimeVatEmailInformation();
      } else if (res?.message) {
        openNotification(
          "error",
          res?.message || "Error updating basic information",
        );
      }
    } catch (error) {
      openNotification("error", "Error updating basic information");
    } finally {
      setLoading(false);
    }
  };

  const getToItems = async (filter: string, practiceId: number) => {
    if (filter) {
      const result = await PracticesService.search(practiceId, filter, 0);
      return result?.items || [];
    }
    return [];
  };
  const handleSearch = async (value: any) => {
    if (!value) return;
    const items = await getToItems(value, practiceId);
    setBCCOptions(
      items.map((itm: any) => ({ name: itm?.fullName, email: itm?.email })),
    );
    setCCOptions(
      items.map((itm: any) => ({ name: itm?.fullName, email: itm?.email })),
    );
  };
  const handleCancel = () => {
    if (initialValues) {
      form.setFieldsValue(initialValues);
    }
    setIsEdit({ type: PracticeUpdateTypes.unknown });
  }
  return (
    <Form
      form={form}
      // onValuesChange={handleValuesChange}
      disabled={isViewOnly}
    >
      <Col className="card border pb-3 border-rounded-1 bg-secondary">
        <Row
          className="border-bottom  px-2 py-1 font-bold"
          justify="space-between"
        >
          Time zone, VAT
          {!isViewOnly &&
            <Button
              icon={<EditTwoTone />}
              type="text"
              // disabled={isInactive}
              style={{ border: "none" }}
              onClick={() => setIsEdit({ type: PracticeUpdateTypes.timeZoneVat })}
            />
          }
        </Row>
        <Row className="px-3 pt-1">
          <Col span={12}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 16 }}
              label="Time zone"
              name="timeZone"
            >
              <Select
                disabled={
                  isEdit.type === PracticeUpdateTypes.timeZoneVat ? false : true
                }
                showSearch
                className="line-height-28"
                placeholder="TimeZone"
                options={getTimeZoneOptions()}
              />
            </Form.Item>
          </Col>
          <Col
            span={6}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "180px",
            }}
          >
            <Form.Item
              className="custom-form-item"
              valuePropName="checked"
              name={["vat", "enabled"]}
              style={{ marginTop: 30, marginBottom: 0 }}
            >
              <Checkbox
                disabled={
                  isEdit.type === PracticeUpdateTypes.timeZoneVat ? false : true
                }
                className="line-height-28"
              >
                VAT
              </Checkbox>
            </Form.Item>

            <Form.Item shouldUpdate noStyle>
              {({ getFieldValue }) =>
                getFieldValue(["vat", "enabled"]) ? (
                  <Form.Item
                    className="custom-form-item"
                    name={["vat", "rate"]}
                    label="VAT rate (%)"
                    style={{ marginTop: 30, marginBottom: 0 }}
                  >
                    <Input
                      disabled={
                        isEdit.type === PracticeUpdateTypes.timeZoneVat
                          ? false
                          : true
                      }
                      onKeyPress={(e) => Utils.ValidateNumberOnly(e)}
                      className="line-height-28"
                      placeholder="VAT Rate"
                    />
                  </Form.Item>
                ) : null
              }
            </Form.Item>
          </Col>
        </Row>
        {!isViewOnly && isEdit.type === PracticeUpdateTypes.timeZoneVat && (
          <Row className="px-3 pt-3">
            <Button type="primary" onClick={saveTimeVatEmailDetails}>
              <SaveOutlined /> Save
            </Button>
            <Button
              className="ms-2"
              onClick={handleCancel}
            >
              <CloseOutlined /> Cancel
            </Button>
          </Row>
        )}
      </Col>
      <Col className="card border pb-3 border-rounded-1 bg-secondary my-4">
        <Row
          className="border-bottom  px-2 py-1 font-bold"
          justify="space-between"
        >
          Emails
          {!isViewOnly &&
            <Button
              icon={<EditTwoTone />}
              type="text"
              // disabled={isInactive}
              style={{ border: "none" }}
              onClick={() => setIsEdit({ type: PracticeUpdateTypes.emails })}
            />
          }
        </Row>
        <Row className="px-4 pt-2">
          <Col span={8} style={{ display: "flex", alignItems: "center" }}>
            <Form.Item
              style={{ width: "100%" }}
              className="custom-form-item"
              name="emailProvider"
            >
              <Radio.Group
                style={{ display: "flex" }}
                disabled={
                  isEdit.type === PracticeUpdateTypes.emails ? false : true
                }
              >
                <div style={{ marginRight: 135 }}>
                  <Radio
                    value={0}
                    className="border  border-rounded-1 mail-radio-btn"
                  >
                    <span className="mail-radio-btn-span">
                      <img
                        style={{ height: 20, width: 20 }}
                        alt="email"
                        src="https://cdn-icons-png.flaticon.com/512/5968/5968534.png"
                      />
                      <div>Gmail</div>
                    </span>
                  </Radio>
                </div>
                <Radio
                  value={1}
                  className="border  border-rounded-1 mail-radio-btn"
                >
                  <span className="mail-radio-btn-span">
                    <img
                      style={{ height: 24, width: 24 }}
                      alt="email"
                      src="https://img.icons8.com/?size=200&id=RUIFhdJm8fbJ&format=png&color=000000"
                    />
                    <div>Outlook</div>
                  </span>
                </Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 12 }}
              label="CCs"
              name="defaultCCs"
            >
              <Select
                mode="multiple"
                showSearch
                value={selectedCC}
                // defaultValue={["a0000", "c111"]}
                className="line-height-28"
                disabled={
                  isEdit.type === PracticeUpdateTypes.emails ? false : true
                }
                placeholder="CCs"
                options={ccOptions.map((item) => ({
                  label: item?.name,
                  value: item?.email,
                }))}
                onSearch={handleSearch}
                onChange={(item: any) => {
                  setSelectedCC({ label: item?.name, name: item?.email });
                }}
              ></Select>
            </Form.Item>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 12 }}
              label="BCCs"
              name="defaultBCCs"
            >
              <Select
                className="line-height-28"
                mode="multiple"
                showSearch
                disabled={
                  isEdit.type === PracticeUpdateTypes.emails ? false : true
                }
                value={selectedBcc}
                onSearch={handleSearch}
                onChange={(item: any) => {
                  setSelectedBcc({ label: item?.name, name: item?.email });
                }}
                placeholder="BCCs"
                options={bccOptions.map((item) => ({
                  label: item?.name,
                  value: item?.email,
                }))}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              className="custom-form-item"
              valuePropName="checked"
              name={["noReply", "enabled"]}
              style={{ marginTop: 28 }}
            >
              <Checkbox
                disabled={
                  isEdit.type === PracticeUpdateTypes.emails ? false : true
                }
                className="line-height-28"
              >
                Enable no-reply section
              </Checkbox>
            </Form.Item>

            <Form.Item shouldUpdate noStyle>
              {({ getFieldValue }) => (
                <Form.Item
                  className="custom-form-item"
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 18 }}
                  label="Reply to email address"
                  name={["noReply", "replyEmail"]}
                  rules={[
                    { validator: Utils.ValidateEmailFormat },
                    { required: getFieldValue(["noReply", "enabled"]) ? true : false, message: "Reply to email address is required" }
                  ]}
                  style={{ marginTop: 18 }}
                >
                  <Input
                    disabled={
                      !getFieldValue(["noReply", "enabled"]) ||
                      isEdit.type !== PracticeUpdateTypes.emails
                    }
                    className="line-height-28"
                    placeholder="Reply to email address"
                  />
                </Form.Item>
              )}
            </Form.Item>
          </Col>
        </Row>
        {!isViewOnly && isEdit.type === PracticeUpdateTypes.emails && (
          <Row className="px-3 pt-3">
            <Button type="primary" onClick={saveTimeVatEmailDetails}>
              <SaveOutlined /> Save
            </Button>
            <Button
              className="ms-2"
              onClick={handleCancel}
            >
              <CloseOutlined /> Cancel
            </Button>
          </Row>
        )}
      </Col>
    </Form>
  );
};

export default TimeZoneVATAndEmail;
